export type InterfaceColorMode = "light" | "dark";

/** Shared visual vocabulary for the operator UI, administration and authored variants. */
export const designTokens = {
  light: {
    background: "#fdfdfd",
    fine: "#e9e9ec",
    fill: "#e8e9ed",
    onAccent: "#ffffff",
    surface: "#ffffff",
    chrome: "#f3f3f5",
    border: "#dedfe3",
    text: "#25262a",
    muted: "#61636a",
    accent: "#276be9",
    selected: "#edf1fc",
    success: "#25805a",
    warning: "#946000",
    error: "#cb4b4b",
  },
  dark: {
    background: "#202124",
    fine: "#303238",
    fill: "#303239",
    onAccent: "#121b2f",
    surface: "#25262a",
    chrome: "#1a1b1e",
    border: "#393b42",
    text: "#ececef",
    muted: "#b2b3ba",
    accent: "#8ab4ff",
    selected: "#303e61",
    success: "#84caa2",
    warning: "#e8bd68",
    error: "#e48181",
  },
} as const;
export const interfaceFont =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
